module.exports = __webpack_public_path__ + "a5cdba968f4201525b31903f973d3b3b.png";